import React from 'react'

import Advert from '~/components/blocks/MagazineAdvert/Advert'

import { ADVERT_CONFIG } from './advertConfig'

import styles from '~/styles/pages.module.css'

interface MobileAdvertProps {
  advert: any
  modules: any[] | null
  isValuationsOldBannerAd: boolean
  isMobile: boolean
}

/**
 * Mobile-specific advert component
 * Renders a static (non-sticky) advert at the top of article content on mobile devices
 */
const MobileAdvert: React.FC<MobileAdvertProps> = ({
  advert,
  modules,
  isValuationsOldBannerAd,
  isMobile,
}) => {
  // Don't render if conditions aren't met
  if (
    !isMobile ||
    !advert?.landscapeImage ||
    !modules ||
    modules.length <= ADVERT_CONFIG.MIN_MODULES_FOR_MOBILE ||
    isValuationsOldBannerAd
  ) {
    return null
  }

  return (
    <div className={styles.articleStickyAdvert}>
      <Advert {...advert} />
    </div>
  )
}

export default MobileAdvert
